import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Filter from '../components/Filter';
import { visibilityFilterSet } from '../reducers/contacts';
import styles from '../styles/filterList.scss';
const ContactFilterList = ({ filters }) => {
    const dispatch = useDispatch();
    const selectedFilter = useSelector((state) => state.contacts.visibilityFilter);
    return (React.createElement("div", { className: styles.filter_container }, filters.map((filter, i) => (React.createElement(Filter, { key: i, selected: selectedFilter === filter.value, onClick: () => {
            dispatch(visibilityFilterSet({ filter: filter.value }));
        } }, filter.name)))));
};
export default ContactFilterList;
